"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormQuestion = exports.QuestionsAsJobProperties = void 0;
const typeorm_1 = require("typeorm");
const order_form_question_populated_job_field_enum_1 = require("./order-form-question-populated-job-field-enum");
const data_ui_1 = require("../../data-ui");
const contact_profile_enum_1 = require("../contact-profile-enum");
const flow_1 = require("./flow");
const order_form_question_lang_1 = require("./order-form-question-lang");
const order_form_question_type_1 = require("./order-form-question-type");
var QuestionsAsJobProperties;
(function (QuestionsAsJobProperties) {
    QuestionsAsJobProperties["CAR_DELIVERY"] = "car_delivery";
})(QuestionsAsJobProperties = exports.QuestionsAsJobProperties || (exports.QuestionsAsJobProperties = {}));
let OrderFormQuestion = class OrderFormQuestion {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 255,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {}),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "dependsOn", void 0);
__decorate([
    (0, typeorm_1.Column)('json', {
        nullable: true,
    }),
    __metadata("design:type", Array)
], OrderFormQuestion.prototype, "triggers", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: order_form_question_type_1.OrderFormQuestionTypeEnum,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "questionType", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], OrderFormQuestion.prototype, "multiple", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('integer', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], OrderFormQuestion.prototype, "sort", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], OrderFormQuestion.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], OrderFormQuestion.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], OrderFormQuestion.prototype, "deletedAt", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => flow_1.Flow),
    __metadata("design:type", flow_1.Flow)
], OrderFormQuestion.prototype, "flow", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('uuid', {
        name: 'flow_id',
        nullable: false,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "flowId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "suffix", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: true,
        enum: order_form_question_populated_job_field_enum_1.OrderFormQuestionPopulatedJobFieldEnum,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "populatedJobField", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], OrderFormQuestion.prototype, "storeAsJobProperty", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
    }),
    __metadata("design:type", Boolean)
], OrderFormQuestion.prototype, "required", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => order_form_question_lang_1.OrderFormQuestionLang, (item) => item.question, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], OrderFormQuestion.prototype, "translations", void 0);
__decorate([
    (0, typeorm_1.Column)('json', {
        name: 'metadata',
        nullable: true,
    }),
    __metadata("design:type", Object)
], OrderFormQuestion.prototype, "metadata", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: true,
    }),
    __metadata("design:type", Boolean)
], OrderFormQuestion.prototype, "autoTemplateRender", void 0);
OrderFormQuestion = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'OrderFormQuestion',
        nameProperties: ['id', 'name'],
    }),
    (0, typeorm_1.Entity)('order_form_question', { schema: 'order_intake_forms' })
], OrderFormQuestion);
exports.OrderFormQuestion = OrderFormQuestion;
//# sourceMappingURL=order-form-question.js.map